import React from 'react';
import { useLocation } from 'react-router-dom';

import { RenderBlocks } from '@plone/volto/components';
import { TabbedContent } from '@designsystem/stories/04-organisms/TabbedContent';

const View = (props) => {
  const { tabsList = [], tabs = {} } = props;

  // Read the hash deferred to avoid an SSR/client hydration mismatch
  const location = useLocation();
  const [hashId, setHashId] = React.useState('');
  React.useEffect(() => {
    setHashId(location.hash.slice(1));
  }, [location.hash]);

  const items = tabsList.map((key, i) => {
    const tab = tabs[key];

    return {
      id: key,
      label: tab?.title || `Tab ${i + 1}`,
      children: <RenderBlocks content={tab} />,
    };
  });

  return <TabbedContent items={items} activeId={hashId} />;
};

export default View;
